export const dlProductOtherProductViewedEvent = () => {
    if (document.cookie.includes('dLUSeePP')) {
        window.dataLayer.push({
            event: 'user_viewed_other_product'
        });
    }
    else {
        document.cookie = 'dLUSeePP=true; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT; sameSite=lax;';
    }
};
